import { useState } from "react";
import { i18n } from "../../../../localization/i18n";

import { showToast } from "../../../../components/CustomToast";
import { StepPersonalData } from "./Components/StepPersonalData";
import { StepDelivery } from "./Components/StepDelivery";
import { StepCheckout } from "./Components/StepCheckout";
import { StepSuccess } from "./Components/StepSuccess";

import api from "../../../../services/api";

import { customerSituations, personTypes, roles } from "../../../../utils/constants";
import LogoImg from "../../../../assets/logo.svg";

import {
  Container,
  ProductBanner,
  ProductThumbnail,
  ProductTitle,
  FormContainer,
  StepperContainer,
  StepTab,
} from "./styles";

import { IAuthFormData, IPersonFormData, ICheckoutData } from "./dtos.d";

export function FixiterRegistration() {
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  
  const [authFormData, setAuthFormData] = useState<IAuthFormData>();
  const [personFormData, setPersonFormData] = useState<IPersonFormData>({
    name: "",
    email: "",
    cpf: "",
    expertise: "",
    professional_number: "",
    cellphone: "",
    cep: "",
    address: "",
    number: "",
    noNumber: false,
    complement: "",
    noComplement: false,
    district: "",
    city: "",
    state: "",
    hasHeatGun: true,
    heatGunVoltage: ""
  });
  const [checkoutData, setCheckoutData] = useState<ICheckoutData>({
    paymentPlan: null,
    installments: 1,
    totalValue: 0,
    useStudentData: true,
    billingType: "FISICA",
    billingName: "",
    billingDocument: "",
    billingEmail: "",
    useDeliveryAddressForBilling: true,
    billingCep: "",
    billingAddress: "",
    billingNumber: "",
    billingNoNumber: false,
    billingComplement: "",
    billingNoComplement: false,
    billingDistrict: "",
    billingCity: "",
    billingState: ""
  });

  const [transactionCode, setTransactionCode] = useState<string>("");
  const [paymentLink, setPaymentLink] = useState<string>("");

  const nextStep = () => setActiveStep((prevStep) => prevStep + 1);
  const prevStep = () => setActiveStep((prevStep) => prevStep - 1);


  const steps = [
    {
      label: "Dados do Participante",
      component: (
        <StepPersonalData
          personFormData={personFormData}
          setPersonFormData={setPersonFormData}
          nextStep={nextStep}
          loading={loading}
        />
      ),
    },
    {
      label: "Endereço",
      component: (
        <StepDelivery
          personFormData={personFormData}
          setPersonFormData={setPersonFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          loading={loading}
        />
      ),
    },
    {
      label: "Pagamento",
      component: (
        <StepCheckout
          personFormData={personFormData}
          checkoutData={checkoutData}
          setCheckoutData={setCheckoutData}
          nextStep={nextStep}
          prevStep={prevStep}
          loading={loading}
          setLoading={setLoading}
          transactionCode={transactionCode}
          setTransactionCode={setTransactionCode}
          paymentLink={paymentLink}
          setPaymentLink={setPaymentLink}
        />
      ),
    },
    {
      label: "Obrigado",
      component: (
        <StepSuccess
          authFormData={authFormData}
          setAuthFormData={setAuthFormData}
          personFormData={personFormData}
          checkoutData={checkoutData}
          loading={loading}
          setLoading={setLoading}
          prevStep={prevStep}
          transactionCode={transactionCode}
        />
      ),
    },
  ];

  return (
    <Container>
      <ProductBanner>
        <ProductThumbnail>
          <img src={LogoImg} alt="Fix it 3D" />
        </ProductThumbnail>
        <ProductTitle>Curso Órteses Fix it 3D</ProductTitle>
      </ProductBanner>

      <FormContainer>
        {activeStep < 3 && (
          <StepperContainer>
            {steps.slice(0, 3).map((step, index) => {
              const isActive = activeStep === index;
              const isCompleted = activeStep > index;

              return (
                <StepTab key={index} active={isActive} completed={isCompleted}>
                  <div className="step-circle">{isCompleted ? "✓" : index + 1}</div>
                  {step.label}
                </StepTab>
              );
            })}
          </StepperContainer>
        )}

        {steps[activeStep]?.component}
      </FormContainer>
    </Container>
  );
}

export default FixiterRegistration;
